import React from "react";

function PersonalInjury() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Personal Injury</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              Injuries suffered at work or anywhere else along with fatalities resulted from all sorts of accidents will require taking further steps to take the matter to court.  Victims or their families will seek compensation and will therefore require legal representation.
              </p>
              <p>
              This area highly overlaps with litigation and has a high focus on cooperating with experts and witnesses.
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default PersonalInjury;
